import { useProjects } from '../api/hooks';
import { projectOptions } from './project-options';
import { Select } from '../components';

export function ProjectSelect({
  value,
  onChange,
  includeAll = true,
  label = 'Project',
  id,
}: {
  value: number;
  onChange: (id: number) => void;
  includeAll?: boolean;
  label?: string;
  id?: string;
}) {
  const projects = useProjects();
  return (
    <Select
      aria-label={label}
      {...(id ? { id } : {})}
      value={String(value)}
      onChange={(e) => onChange(Number(e.target.value))}
      options={projectOptions(projects.data ?? [], includeAll)}
      disabled={projects.isPending}
    />
  );
}
